"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THREAD_STATUS = exports.SIDEBAR = exports.ROLES = exports.FEATURE_META = exports.FEATURES = exports.DEFAULT_LOADING_MESSAGES = exports.COMPOSER_PLACEHOLDERS = void 0;
const FEATURES = exports.FEATURES = Object.freeze({
  EID_INSIGHTS: 'EID_INSIGHTS',
  INCIDENT_ANALYSIS: 'INCIDENT_ANALYSIS',
  DATA_RETRIEVAL: 'DATA_RETRIEVAL',
  GENERAL: 'GENERAL'
});
const FEATURE_META = exports.FEATURE_META = Object.freeze({
  [FEATURES.EID_INSIGHTS]: {
    id: FEATURES.EID_INSIGHTS,
    title: 'EID Insights',
    subtitle: 'Understand identity at a glance',
    description: 'Get a summary of demographics, anomalies, duplicate signals, and recommended next steps for any EID.',
    icon: '🔎',
    color: '#367796',
    samplePrompts: ['Show EID Insights', 'Summarize EID 123456', 'Are there any anomalies for this identity?'],
    loadingMessages: ['✅ Getting things ready…', '🔍 Checking member details…', '📊 Analyzing demographics for patterns…', '🔗 Running overmerge analysis…', '💡 Generating insights…', '📝 Preparing your report…']
  },
  [FEATURES.INCIDENT_ANALYSIS]: {
    id: FEATURES.INCIDENT_ANALYSIS,
    title: 'Incident Analysis',
    subtitle: 'Resolve ServiceNow incidents faster',
    description: 'Provide an incident ID and description to get root-cause hypotheses, recommended checks, and next-best actions.',
    icon: '🛠️',
    color: '#BF9055',
    samplePrompts: ['Get Incident Analysis & Recommendations', 'Analyze INC123456 — user record mismatch', 'What could cause a duplicate EID for this incident?'],
    loadingMessages: ['✅ Understanding your request…', '📌 Identifying what kind of help you need', '🔍 Looking for similar past cases…', '🔗 Connecting to the right expert system', '💡 Preparing smart recommendations…', '✔️ Checking against business rules…', '📦 Putting together the final response…']
  },
  [FEATURES.DATA_RETRIEVAL]: {
    id: FEATURES.DATA_RETRIEVAL,
    title: 'Data Retrieval',
    subtitle: 'Cross-system record lookup',
    description: 'Retrieve records from CDC, DynamoDB, GraphQL, or User Service — then compare across systems to spot discrepancies.',
    icon: '📦',
    color: '#404494',
    samplePrompts: ['Get Record/Aggregate Data Across Systems', 'Get CDC Record', 'Compare DynamoDB patient record with GraphQL CDB'],
    loadingMessages: ['✅ Getting things ready…', '🔍 Querying the data source…', '📊 Parsing response…', '🔗 Cross-referencing records…', '💡 Highlighting differences…', '📝 Formatting results…']
  }
});
const THREAD_STATUS = exports.THREAD_STATUS = Object.freeze({
  ACTIVE: 'active',
  ARCHIVED: 'archived'
});
const ROLES = exports.ROLES = Object.freeze({
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system'
});
const DEFAULT_LOADING_MESSAGES = exports.DEFAULT_LOADING_MESSAGES = ['✅ Understanding your request…', '📌 Identifying what kind of help you need', '🔍 Looking for similar past cases…', '🔗 Connecting to the right expert system', '🧩 Fetching details and demographics…', '💡 Preparing smart recommendations…', '✍️ Polishing the response for clarity…', '✔️ Checking against business rules…', '📦 Putting it all together…'];
const SIDEBAR = exports.SIDEBAR = Object.freeze({
  MIN_WIDTH: 420,
  DEFAULT_WIDTH: 500,
  MAX_WIDTH: 1200
});
const COMPOSER_PLACEHOLDERS = exports.COMPOSER_PLACEHOLDERS = Object.freeze({
  [FEATURES.EID_INSIGHTS]: 'Enter an EID or ask about identity insights…',
  [FEATURES.INCIDENT_ANALYSIS]: 'Describe the incident or paste an INC number…',
  [FEATURES.DATA_RETRIEVAL]: 'Enter a record ID or select a data source…',
  [FEATURES.GENERAL]: 'Ask EIMP SmartAssist anything…'
});